"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pillbox = void 0;
class Pillbox {
    constructor(props) {
        this.active = props?.active || false;
        this.checkedTaken = props?.checkedTaken || false;
        this.country = props?.country || null;
        this.dni = props?.dni || null;
        this.dose = props?.dose || 0;
        this.end_date = props?.end_date || null;
        this.format = props?.format || null;
        this.imagePath = props?.imagePath || null;
        this.initial_date = props?.initial_date || null;
        this.link_id = props?.link_id || null;
        this.medicine = props?.medicine || null;
        this.messages = props?.messages ||
            {
                mon: [],
                tue: [],
                wed: [],
                thu: [],
                fri: [],
                sat: [],
                sun: []
            };
        this.notification_id = props?.notification_id || null;
        this.notify = props?.notify || false;
        this.obs = props?.obs || null;
        this.personalized = props?.personalized || false;
        this.pillbox_id = props?.pillbox_id;
        this.quantity_days = props?.quantity_days || 0;
        this.stock = props?.stock || 0;
        this.timestamps = props?.timestamps;
        this.uid = props?.uid;
        this.username = props?.username || null;
    }
}
exports.Pillbox = Pillbox;
